import { Directive, HostListener, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ServerConfigService } from '../service/server-config.service';

@Directive({
  selector: '[appOpenErrorReport]'
})
export class OpenErrorReportDirective {

/**
 * 素材的sourceType
 *
 */
  @Input() path: string;
/**
 * 素材的uid
 *
 */
  @Input() uuid: string;
/**
 * 素材本身的detail網址
 *
 */
  @Input() sourceUrl: string;
/**
 * 素材的標題
 *
 */
  @Input() sourceTitle: string;
/**
 * 素材的資料來源
 *
 */
  @Input() sourceOrg: string;


  constructor(
    protected route: ActivatedRoute,
    protected router: Router,
    protected serverConfigService: ServerConfigService,
  ) { }

  @HostListener('click')
  openTab() {
    if (!this.path || !this.uuid || !this.sourceUrl) {
      // 如果path/uuid/sourceUrl 其中一個未定義則拋出錯誤
      throw new Error('path 或 uuid 或 sourceUrl 未定義 (path or uuid or sourceUrl is undefined)');
    }
    const host = location.origin; // 取得base url
    const lang = this.serverConfigService.config.lang; // 取得語系
    const urlTree = this.router.createUrlTree(['errorReport'], { queryParams: { path: this.path, uuid: this.uuid, sourceUrl: this.sourceUrl, sourceTitle: this.sourceTitle, sourceOrg: this.sourceOrg } });
    const serializeUrl = this.router.serializeUrl(urlTree); // 建立網址樹並且序列化
    const fullRedirectUrl = `${host}/${lang}${serializeUrl}`; // 組成最終網址

    window.open(fullRedirectUrl, '_blank'); // 開在新分頁

  }

}
